import { ENDPOINT } from '../globals/endpoint';
import { apiHelper } from '../helpers/api-helper';

export interface CreateApplicationReturn {
  leaseId: string;
  status: 'APP_APPROVED' | 'APP_PENDING' | 'APP_DENIED' | 'APP_SUBMIT_FAILURE' | 'FIND_VERIFY';
  approvalLimit: number;
  validThrough: string;
  creditCardLastFour?: string;
  customerId: string;
}

export const createApplication = async (): Promise<CreateApplicationReturn | undefined> => {
  const endpoint = ENDPOINT.LeaseAppSubmit;

  const response = await apiHelper(endpoint, { method: 'POST', body: JSON.stringify({ threatMetrixSessionId: window.ProgConnect.threatMetrixSessionId ?? '' }) });

  const resp = await response.json();

  return response.ok ? resp : void 0;
};
